import { getAdditionalSearchParameters } from "../../../utils/search/additionalSearchParameters.js";

export const searchAndFilterComputed = {
  computed: {
    searchFilterColorStyles() {
      if (this.jobSearchGlobal) {
        const { accentColor, pageBackgroundColor } =
          this.jobSearchGlobal.config.general;

        return {
          "--search-filter-accent-color": accentColor.value,
          "--search-filter-bg-color": pageBackgroundColor.value,
        };
      }
    },
  },
};

export const searchAndFilterMethods = {
  data() {
    return {
      aroundRadius: "",
      aroundLatLng: "",
      resetAutocomplete: false,
    };
  },
  computed: {
    coordinateFilter() {
      if (!this.aroundLatLng || !this.aroundRadius) return "";
      return `coordinate:(${this.aroundLatLng}, ${this.aroundRadius / 1000}km)`;
    },
  },
  methods: {
    // Converts current refinement values or defaults to range values
    toValue(value, range) {
      return [
        typeof value.min === "number" ? value.min : range.min,
        typeof value.max === "number" ? value.max : range.max,
      ];
    },
    // Updates the refinement based on slider changes
    refineRange(refine, values) {
      refine({ min: values[0], max: values[1] });
    },
    setSliderTooltipOrientation(event, range, filterKey) {
      const currentMinValue = event[0];
      const currentMaxValue = event[1];

      // Determine midValue
      const midValue = (range.min + range.max) / 2;

      // Check if currentMinValue is greater than midValue
      const isMinGreaterThanMid = currentMinValue > midValue;

      // Check if currentMaxValue is smaller than midValue
      const isMaxSmallerThanMid = currentMaxValue < midValue;

      // Set css vars appropriately
      this.$refs[`slider-${filterKey}`].style.setProperty(
        "--lower-tooltip-transform",
        isMinGreaterThanMid ? "-75%" : "inherit",
      );
      this.$refs[`slider-${filterKey}`].style.setProperty(
        "--upper-tooltip-transform",
        isMaxSmallerThanMid ? "0%" : "-75%",
      );
    },
    updateSearchParameters(event) {
      const isMapView = event === "map";

      if (!this.typesenseInstantsearchAdapter) return;

      // Update the adapter with new parameters based on view mode
      this.typesenseInstantsearchAdapter.configuration.additionalSearchParameters =
        getAdditionalSearchParameters(isMapView ? "map" : "default");
    },
    // Location autocomplete and radius methods
    filterAddress(address) {
      this.aroundLatLng = address.lat + "," + address.lon;
    },
    clearAddress() {
      this.aroundLatLng = "";
      this.aroundRadius = "";
    },
    changeRadius(km) {
      this.aroundRadius = km;
    },
    resetAllFilters(refine) {
      refine();
      this.clearAddress();
      this.resetAutocomplete = true;
      this.$nextTick(() => {
        this.resetAutocomplete = false;
      });
    },
  },
};
